import { ref } from 'vue';
import { defineStore } from "pinia";

export const useAuthPopupStore = defineStore('auth-popup', () => {
    const showAuthPopup = ref(false);
    const showPopupOpenAnimation = ref(false);

    const setShowAuthPopup = () => {
        if(showAuthPopup.value === true) {
            showPopupOpenAnimation.value = true;

            setTimeout(() => {
                showPopupOpenAnimation.value = false;
            }, 1100)
        }else{
            showAuthPopup.value = true;
        }
    }

    const hideShowAuthPopup = () => {
        showPopupOpenAnimation.value = false;
        showAuthPopup.value = false;
    }

    return {
        showAuthPopup,
        showPopupOpenAnimation,

        setShowAuthPopup,
        hideShowAuthPopup
    }
})
